import { createReducer } from "@reduxjs/toolkit";
import { IClientFolderState } from "./types";
import * as actions from "./actions";
import { StoreState } from "../storeState";
import { STORAGE_RESET } from "../storeReset";

const initialState = {
  data: [],
  state: StoreState.None,
} as IClientFolderState;

export const clientFolderReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(actions.clientFolderFetchRequest, (state) => ({
      ...state,
      state: StoreState.Loading,
    }))
    .addCase(actions.clientFolderFetchSuccess, (state, action) => ({
      ...state,
      state: StoreState.Loaded,
      data: action.payload,
    }))
    .addCase(actions.clientFolderFetchError, (state) => ({
      ...state,
      state: StoreState.Error,
    }))
    .addCase(STORAGE_RESET, () => initialState)
);
